<template>
    <div class="model-data-warehousing">
        <div class="main-content-top">
              <div class="left">
                {{warehousingPreviewTitle}}
              </div>
              <div class="right">
                  <el-button type="primary" @click="closeWarehousingPreview">关闭</el-button>
              </div>
        </div>
      <div class="main-content-center">
          <grid-layout
             :layout="warehousing"
             :col-num="96"
             :row-height="5"
             :is-draggable="isDraggable"
             :is-resizable="isResizable"
             :is-mirrored="false"
             :autoSize="true"
             :vertical-compact="true"
             :margin="[10, 10]"
             :use-css-transforms="true"
             @layout-created="layoutCreatedEvent"
             @layout-before-mount="layoutBeforeMountEvent"
             @layout-mounted="layoutMountedEvent"
             @layout-ready="layoutReadyEvent"
             @layout-updated="layoutUpdatedEvent"
           >
             <grid-item v-for="(item,index) in warehousing"
                :x="item.x"
                :y="item.y"
                :w="item.w"
                :h="item.h"
                :i="item.i"
                :key="item.i"
                @resize="resizeEvent"
                @move="moveEvent"
                @resized="resizedEvent"
                @moved="movedEvent"
             >
                <div class="tool-bar" v-if="item.name!==''">
                    <div class="tit">
                        <input type="text" disabled="disabled" v-model="item.name" class="grid-item-title"/>
                    </div>
                    <div class="tool-bar-opera">
                       <div class="search-tool" v-if="item.dataType===1||item.dataType===3||item.dataType===4">
                            <i class="iconfont icon-other-xuanzhong2x" @click="showItemSearch(item)"></i>
                            <i class="iconfont icon-other-quanping" @click="fullScreenShow(item)"></i>
                        </div>
                    </div>
                </div>
                <div class="main-content-body">
                    <!-- BI -->
                    <DashBoard  :ref="item.i+'dashBoard'"  v-if="item.dataType===1"
                                :dashBoardWidth="item.dashBoardWidth"
                                :dashBoardHeight="item.dashBoardHeight"
                                :showSearchList="item.showSearchList"
                                :chartType="item.chartType"
                                :searchCondition="item.searchCondition"
                                :dataId="item.dataId"
                                :cacheDataId="item.id"
                                :index="item.id"
                                >
                    </DashBoard>
                    <!-- 工作台 -->
                    <WorkPlant
                            :ref="item.i+'workPlant'"
                            v-if="item.dataType===2"
                            :dataList="item.dataList"
                            >
                    </WorkPlant>
                    <!-- 数据表格 -->
                    <TableData
                            :ref="item.i+'dataTable'"
                            v-if="item.dataType===3"
                            :itemRef="item"
                            :modelId="item.modelId"
                            :formId="item.formId"
                            :showSearchList="item.showSearchList"
                            :modelObj="item.modelObj"
                            :searchCondition="item.searchCondition"
                            :selectedFields="item.selectedFields"
                            :selectedModel="item.selectedModel"
                            :tableHeight="item.tableHeight"
                            :hiddenPage="false"
                            >
                    </TableData>
					<!-- 数据报表 -->
					<TableData
					        :ref="item.i+'dataTable'"
					        v-if="item.dataType===4"
                            :itemRef="item"
					        :modelId="item.modelId"
					        :formId="item.formId"
                            :showSearchList="item.showSearchList"
					        :modelObj="item.modelObj"
                            :selectedFields="item.selectedFields"
                            :searchCondition="item.searchCondition"
					        :selectedModel="item.selectedModel"
					        :tableHeight="item.tableHeight"
                            :hiddenPage="false"
					        >
					</TableData>
                    <!-- 聚合报表 -->
                    <TableData
                            :ref="item.i+'dataTable'"
                            v-if="item.dataType===11"
                            :modelId="item.modelId"
                            :formId="item.formId"
                            :modelObj="item.modelObj"
                            :showSearchList="item.showSearchList"
                            :searchCondition="item.searchCondition"
                            :selectedFields="item.selectedFields"
                            :selectedModel="item.selectedModel"
                            :tableHeight="item.tableHeight"
                            :hiddenPage="true"
                            >
                    </TableData>
                    <!-- 单项值统计 -->
                    <StatisticsPreview
                            v-if="item.dataType===5"
                            :fieldConfig="item.fieldConfig"
                            :cacheDataId="item.id"
                            >

                    </StatisticsPreview>
                    <!-- 数字化工具 -->
                    <DigitalToolsPreview
                            :ref="item.i+'digitalTools'"
                            :dataList="item.dataList"
                            v-if="item.dataType===6"
                            >
                    </DigitalToolsPreview>
                    <!-- 快捷入口 -->
                    <QuickEntry
                            :ref="item.i+'quickEntry'"
                            v-if="item.dataType===7"
                            :mode="item.mode"
                            :chooseDataIds="item.chooseDataIds"
                            :dataList="item.dataList"
                            >
                    </QuickEntry>
                    <!-- 分组统计 -->
                    <StatisticsGroupPreview
                       :ref="item.i+'statisticsGroup'"
                       v-if="item.dataType===8"
                       :fieldConfig="item.fieldConfig"
                       :cacheDataId="item.id"
                       >
                    </StatisticsGroupPreview>
                    <!-- 进度条 -->
                    <ProgressBarPreview
                        :ref="item.i+'progressBar'"
                        v-if="item.dataType===9"
                        :progressBarConfig="item.progressBarConfig"
                        >
                    </ProgressBarPreview>
                    <!-- 数据进度 -->
                    <DataProgressBarPreview
                    :ref="item.i+'dataProgressBar'"
                    v-if="item.dataType===10"
                    :dataProgressBarConfig="item.dataProgressBarConfig"
                    >
                    </DataProgressBarPreview>
                </div>
             </grid-item>
           </grid-layout>
           <el-dialog
               title="查询条件"
               append-to-body
               top="4vh"
               custom-class="search-box"
               :visible.sync="isShowSearchConditon">
                  <DataWarehousingSearch
                          :key="currentModelIndex"
                          :ref="currentModelIndex+'dataWarehousingSearch'"
                          :moduleSearchObj="currentModuleSearchObj"
                          >
                  </DataWarehousingSearch>
               <span slot="footer" class="dialog-footer">
                   <el-button @click="celSetFormNew()">关闭</el-button>
                   <el-button type="success" @click="subSetFormNew()">确定</el-button>
               </span>
           </el-dialog>
           <el-dialog :title="showObj.name" :visible.sync="showObjVisible"  append-to-body fullscreen>
                <!-- BI -->
                <DashBoard  :ref="showObj.i+'dashBoard'"  v-if="showObj.dataType===1"
                            :dashBoardWidth="showObj.dashBoardWidth"
                            :dashBoardHeight="showObj.dashBoardHeight"
                            :chartType="showObj.chartType"
                            :searchCondition="showObj.searchCondition"
                            :showSearchList="showObj.showSearchList"
                            :dataId="showObj.dataId"
                            :index="showObj.id"
                            >
                </DashBoard>
                <!-- 数据表格 -->
                <TableData
                        :ref="showObj.i+'dataTable'"
                        v-if="showObj.dataType===3"
                        :itemRef="showObj"
                        :modelId="showObj.modelId"
                        :formId="showObj.formId"
                        :modelObj="showObj.modelObj"
                        :searchCondition="showObj.searchCondition"
                        :selectedFields="showObj.selectedFields"
                        :selectedModel="showObj.selectedModel"
                        :tableHeight="showObj.tableHeight"
                        >
                </TableData>
                <!-- 数据报表 -->
                <TableData
                        :ref="showObj.i+'dataTable'"
                        v-if="showObj.dataType===4"
                        :itemRef="showObj"
                        :modelId="showObj.modelId"
                        :formId="showObj.formId"
                        :modelObj="showObj.modelObj"
                        :selectedFields="showObj.selectedFields"
                        :searchCondition="showObj.searchCondition"
                        :selectedModel="showObj.selectedModel"
                        :tableHeight="showObj.tableHeight"
                        >
                </TableData>
           </el-dialog>
      </div>
    </div>
</template>

<script>
import { cloneDeep } from 'lodash';
import VueGridLayout from 'vue-grid-layout';
import DashBoard from '@/components/DataWarehousing/DashBoard';
import StatisticsPreview from '@/components/DataWarehousing/StatisticsPreview';
import WorkPlant from '@/components/DataWarehousing//WorkPlant';
import TableData from '@/components/DataWarehousing/TableData';
import QuickEntry from '@/components/DataWarehousing/QuickEntry';
import DigitalToolsPreview from '@/components/DataWarehousing/DigitalToolsPreview';
import StatisticsGroupPreview from '@/components/DataWarehousing/StatisticsGroupPreview';
import ProgressBarPreview from '@/components/DataWarehousing/ProgressBarPreview';
import DataProgressBarPreview from '@/components/DataWarehousing/DataProgressBarPreview';
import DataWarehousingSearch from '@/components/DataWarehousing/DataWarehousingSearch';
export default{
    components: {
        GridLayout: VueGridLayout.GridLayout,
        GridItem: VueGridLayout.GridItem,
        DashBoard: DashBoard,
        TableData: TableData,
        WorkPlant: WorkPlant,
        StatisticsPreview: StatisticsPreview,
        QuickEntry: QuickEntry,
        DigitalToolsPreview: DigitalToolsPreview,
        StatisticsGroupPreview: StatisticsGroupPreview,
        ProgressBarPreview: ProgressBarPreview,
        DataProgressBarPreview: DataProgressBarPreview,
        DataWarehousingSearch: DataWarehousingSearch
    },
    props: {
        warehousing: {
            type: Array
        },
        warehousingPreviewTitle: {
            type: String
        }
    },
    data () {
        return {
            // 布局数据
            isDraggable: true,
            isResizable: true,
            statisticsData: [],
            statisticsKey: [],
            biTimer: '',
            spTimer: '',
            wpTimer: '',
            isShowSearchConditon: false,
            currentModelIndex: '',
            currentModuleSearchObj: {},
            currentModule: {},
            showObj: {},
            showObjVisible: false
        };
    },
    watch: {
        // 点击任意处，关闭菜单
        // 'menuConfig.visible' () {
        //     if (this.menuConfig.visible) {
        //         document.body.addEventListener('click', this.closeMenu);
        //     } else {
        //         document.body.removeEventListener('click', this.closeMenu);
        //     }
        // }
    },
    created () {
        // let o = sessionStorage.getItem('warehousing');
        // if (o) {
        //     this.warehousing = JSON.parse(o);
        // }
        // this.$refs.workPlant.test();
        // this.$refs.dashBoard.resizeChart();
    },
    methods: {
        resizeEvent (i, newH, newW, newHPx, newWPx) {
            // console.log('大小正在改变', i, newH, newW, newHPx, newWPx);
        },
        moveEvent (i, newX, newY) {
            // console.log('正在移动', i, newX, newY);
        },
        resizedEvent (i, newH, newW, newHPx, newWPx) {
            let obj = this.warehousing.find(item => item.i === i);
            if (obj.dataType === 1) { // BI
                obj.dashBoardWidth = (newWPx - 20) + 'px';
                obj.dashBoardHeight = (newHPx - 40) + 'px';
                let o = i + 'dashBoard';
                this.$refs[o][0].resizeChart(obj.id);
            }
            // console.log('大小改变完了', i, newH, newW, newHPx, newWPx);
        },
        movedEvent (i, newX, newY) {
            // console.log('移动结束了', i, newX, newY);
        },
        // 布局组件的生命周期  参数newLayout=> 布局的数据 每个布局数据
        layoutCreatedEvent (newLayout) {
            // console.log('1Created');
        },
        layoutBeforeMountEvent (newLayout) {
            // console.log('2Mount');
        },
        layoutMountedEvent (newLayout) {
            // console.log('3Mounted');
        },
        layoutReadyEvent (newLayout) {
            // console.log('4Ready');
        },
        layoutUpdatedEvent (newLayout) {
            // console.log('Updated');
            // console.log(newLayout);
        },
        closeWarehousingPreview () {
            this.$emit('closeWarehousingPreview');
        },
        fullScreenShow (obj) {
            this.showObj = cloneDeep(obj);
            let h = window.innerHeight - 100;
            let w = window.innerWidth - 50;
            if (this.showObj.dataType === 1) {
                this.showObj.dashBoardWidth = w + 'px';
                this.showObj.dashBoardHeight = h + 'px';
            } else if (this.showObj.dataType === 3 || this.showObj.dataType === 4) {
                this.showObj.tableHeight = h + 'px';
            }
            this.showObjVisible = true;
        },
        showItemSearch (obj) {
            let dataType = obj.dataType;
            switch (dataType) {
            case 1:// BI
                if (obj.dataId !== '') {
                    this.currentModelIndex = obj.i;
                    this.currentModuleSearchObj = obj.moduleSearchObj;
                    this.currentModule = obj;
                    this.isShowSearchConditon = true;
                } else {
                    this.$message.error('请先配置BI数据源');
                }
                break;
            case 2:// 工作台
                break;
            case 3:
                if (obj.modelId !== '') {
                    this.currentModuleSearchObj = obj.moduleSearchObj;
                    this.currentModule = obj;
                    this.currentModelIndex = obj.i;
                    this.isShowSearchConditon = true;
                } else {
                    this.$message.error('请先配置数据表格数据源');
                }
                break;
            case 4:
                if (obj.modelId !== '') {
                    this.currentModelIndex = obj.i;
                    this.currentModuleSearchObj = obj.moduleSearchObj;
                    this.currentModule = obj;
                    this.isShowSearchConditon = true;
                } else {
                    this.$message.error('请先配置数据报表数据源');
                }
                break;
            case 5:
                break;
            case 6:
                break;
            case 7:
                break;
            case 8:
                break;
            case 9:
                break;
            case 10:
                break;
            }
        },
        subSetForm (currObj) {
            let obj = this.warehousing.find(item => item.i === currObj.i);
            let o = currObj.i + 'dataWarehousingSearch';
            let conditionFields = this.$refs[o][0].renderSearchArry();
            obj.searchCondition = conditionFields;
            obj.moduleSearchObj.conditionFields = conditionFields;
            switch (currObj.dataType) {
            case 1:
                let re = currObj.i + 'dashBoard';
                this.$refs[re][0].getDashBoardData(currObj.searchCondition);
                break;
            case 3:
                let re1 = currObj.i + 'dataTable';
                this.$refs[re1][0].renderFormList(currObj.modelObj, false, currObj.searchCondition);
                break;
            case 4:
                let re2 = currObj.i + 'dataTable';
                this.$refs[re2][0].renderFormList(currObj.modelObj, false, currObj.searchCondition);
                break;
            }
            obj.moduleSearch = false;
        },
        subSetFormNew () {
            let obj = this.warehousing.find(item => item.i === this.currentModelIndex);
            let o = this.currentModelIndex + 'dataWarehousingSearch';
            let conditionFields = this.$refs[o].renderSearchArry();
            obj.searchCondition = conditionFields;
            obj.moduleSearchObj.conditionFields = conditionFields;
            switch (this.currentModule.dataType) {
            case 1:
                let re = this.currentModule.i + 'dashBoard';
                this.$refs[re][0].getDashBoardData(this.currentModule.searchCondition);
                break;
            case 3:
                let re1 = this.currentModule.i + 'dataTable';
                this.$refs[re1][0].renderFormList(this.currentModule.modelObj, false, this.currentModule.searchCondition);
                break;
            case 4:
                let re2 = this.currentModule.i + 'dataTable';
                this.$refs[re2][0].renderFormList(this.currentModule.modelObj, false, this.currentModule.searchCondition);
                break;
            }
            this.isShowSearchConditon = false;
        },
        celSetForm (currObj) {
            let obj = this.warehousing.find(item => item.i === currObj.i);
            obj.moduleSearch = false;
        },
        celSetFormNew () {
            this.isShowSearchConditon = false;
        }
    }
};
</script>

<style lang="less">
   @import './DataWarehousingPreviewStyle.less';
</style>



// WEBPACK FOOTER //
// src/components/DataWarehousing/DataWarehousingPreview.vue